<template>
<div class="chapter">
<div class="inner_page">
<p><a id="fm1"></a></p>
<div class="fmhT"><b>CREDITS</b></div>
<div class="fmtx1"><b>Executive Editor</b> <br/>Bob Elliott</div>
<div class="fmtx1"><b>Senior Development Editor</b> <br/>Kevin Kent</div>
<div class="fmtx1"><b>Production Editor</b> <br/>Pamela Hanley</div>
<div class="fmtx1"><b>Copy Editor</b> <br/>Nancy Rapoport</div>
<div class="fmtx1"><b>Editorial Manager</b> <br/>Mary Beth Wakefield</div>
<div class="fmtx1"><b>Production Manager</b> <br/>Tim Tate</div>
<div class="fmtx1"><b>Vice President and Executive</b> <br/><b>Group Publisher</b> <br/>Richard Swadley</div>
<div class="fmtx1"><b>Vice President and Executive</b> <br/><b>Publisher</b> <br/>Joseph B. Wikert</div>
<div class="fmtx1"><b>Project Coordinator</b> <br/>Ryan Steffen</div>
<div class="fmtx1"><b>Graphics and Production Specialists</b> <br/>Denny Hager <br/>Jennifer Heleine <br/>Stephanie D. Jumper <br/>Alicia B. South</div>
<div class="fmtx1"><b>Quality Control Technician</b> <br/>Joe Niesen</div>
<div class="fmtx1"><b>Media Development Coordinator</b> <br/>Laura Atkinson</div>
<div class="fmtx1"><b>Proofreading and Indexing</b> <br/>TECHBOOKS Production Services</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wyso_9780470446539_oeb_fm1_r1.vue?0f7ef258